"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * iPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.15.7
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdminLearningModuleApi = exports.AdminLearningModuleApiFactory = exports.AdminLearningModuleApiFp = exports.AdminLearningModuleApiAxiosParamCreator = void 0;
const axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("../common");
// @ts-ignore
const base_1 = require("../base");
/**
 * AdminLearningModuleApi - axios parameter creator
 * @export
 */
exports.AdminLearningModuleApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *  **Permission required**: [\"update\", \"Tenant\"]
         * @summary Create learning module | Permission required: [\"update\", \"Tenant\"]
         * @param {string} [tenantId] tenantId
         * @param {EditCreateLearningModule} [editCreateLearningModule]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLearningModule: (tenantId, editCreateLearningModule, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/admin/learningModule/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (tenantId !== undefined && tenantId !== null) {
                localVarHeaderParameter['tenant-id'] = String(tenantId);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(editCreateLearningModule, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *  **Permission required**: [\"delete\", \"LearningModule\"]
         * @summary Delete learning module | Permission required: [\"delete\", \"LearningModule\"]
         * @param {string} learningModuleId
         * @param {string} [tenantId] tenantId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLearningModule: (learningModuleId, tenantId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'learningModuleId' is not null or undefined
            common_1.assertParamExists('deleteLearningModule', 'learningModuleId', learningModuleId);
            const localVarPath = `/admin/learningModule/{learningModuleId}/`
                .replace(`{${"learningModuleId"}}`, encodeURIComponent(String(learningModuleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (tenantId !== undefined && tenantId !== null) {
                localVarHeaderParameter['tenant-id'] = String(tenantId);
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *  **Permission required**: [\"update\", \"LearningModule\"]
         * @summary Edit learning module | Permission required: [\"update\", \"LearningModule\"]
         * @param {string} learningModuleId
         * @param {string} [tenantId] tenantId
         * @param {EditCreateLearningModule} [editCreateLearningModule]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editLearningModule: (learningModuleId, tenantId, editCreateLearningModule, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'learningModuleId' is not null or undefined
            common_1.assertParamExists('editLearningModule', 'learningModuleId', learningModuleId);
            const localVarPath = `/admin/learningModule/{learningModuleId}/`
                .replace(`{${"learningModuleId"}}`, encodeURIComponent(String(learningModuleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (tenantId !== undefined && tenantId !== null) {
                localVarHeaderParameter['tenant-id'] = String(tenantId);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(editCreateLearningModule, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * AdminLearningModuleApi - functional programming interface
 * @export
 */
exports.AdminLearningModuleApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.AdminLearningModuleApiAxiosParamCreator(configuration);
    return {
        /**
         *  **Permission required**: [\"update\", \"Tenant\"]
         * @summary Create learning module | Permission required: [\"update\", \"Tenant\"]
         * @param {string} [tenantId] tenantId
         * @param {EditCreateLearningModule} [editCreateLearningModule]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLearningModule(tenantId, editCreateLearningModule, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createLearningModule(tenantId, editCreateLearningModule, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *  **Permission required**: [\"delete\", \"LearningModule\"]
         * @summary Delete learning module | Permission required: [\"delete\", \"LearningModule\"]
         * @param {string} learningModuleId
         * @param {string} [tenantId] tenantId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLearningModule(learningModuleId, tenantId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteLearningModule(learningModuleId, tenantId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *  **Permission required**: [\"update\", \"LearningModule\"]
         * @summary Edit learning module | Permission required: [\"update\", \"LearningModule\"]
         * @param {string} learningModuleId
         * @param {string} [tenantId] tenantId
         * @param {EditCreateLearningModule} [editCreateLearningModule]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editLearningModule(learningModuleId, tenantId, editCreateLearningModule, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.editLearningModule(learningModuleId, tenantId, editCreateLearningModule, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
/**
 * AdminLearningModuleApi - factory interface
 * @export
 */
exports.AdminLearningModuleApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.AdminLearningModuleApiFp(configuration);
    return {
        /**
         *  **Permission required**: [\"update\", \"Tenant\"]
         * @summary Create learning module | Permission required: [\"update\", \"Tenant\"]
         * @param {string} [tenantId] tenantId
         * @param {EditCreateLearningModule} [editCreateLearningModule]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLearningModule(tenantId, editCreateLearningModule, options) {
            return localVarFp.createLearningModule(tenantId, editCreateLearningModule, options).then((request) => request(axios, basePath));
        },
        /**
         *  **Permission required**: [\"delete\", \"LearningModule\"]
         * @summary Delete learning module | Permission required: [\"delete\", \"LearningModule\"]
         * @param {string} learningModuleId
         * @param {string} [tenantId] tenantId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLearningModule(learningModuleId, tenantId, options) {
            return localVarFp.deleteLearningModule(learningModuleId, tenantId, options).then((request) => request(axios, basePath));
        },
        /**
         *  **Permission required**: [\"update\", \"LearningModule\"]
         * @summary Edit learning module | Permission required: [\"update\", \"LearningModule\"]
         * @param {string} learningModuleId
         * @param {string} [tenantId] tenantId
         * @param {EditCreateLearningModule} [editCreateLearningModule]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editLearningModule(learningModuleId, tenantId, editCreateLearningModule, options) {
            return localVarFp.editLearningModule(learningModuleId, tenantId, editCreateLearningModule, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * AdminLearningModuleApi - object-oriented interface
 * @export
 * @class AdminLearningModuleApi
 * @extends {BaseAPI}
 */
class AdminLearningModuleApi extends base_1.BaseAPI {
    /**
     *  **Permission required**: [\"update\", \"Tenant\"]
     * @summary Create learning module | Permission required: [\"update\", \"Tenant\"]
     * @param {string} [tenantId] tenantId
     * @param {EditCreateLearningModule} [editCreateLearningModule]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminLearningModuleApi
     */
    createLearningModule(tenantId, editCreateLearningModule, options) {
        return exports.AdminLearningModuleApiFp(this.configuration).createLearningModule(tenantId, editCreateLearningModule, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *  **Permission required**: [\"delete\", \"LearningModule\"]
     * @summary Delete learning module | Permission required: [\"delete\", \"LearningModule\"]
     * @param {string} learningModuleId
     * @param {string} [tenantId] tenantId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminLearningModuleApi
     */
    deleteLearningModule(learningModuleId, tenantId, options) {
        return exports.AdminLearningModuleApiFp(this.configuration).deleteLearningModule(learningModuleId, tenantId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *  **Permission required**: [\"update\", \"LearningModule\"]
     * @summary Edit learning module | Permission required: [\"update\", \"LearningModule\"]
     * @param {string} learningModuleId
     * @param {string} [tenantId] tenantId
     * @param {EditCreateLearningModule} [editCreateLearningModule]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminLearningModuleApi
     */
    editLearningModule(learningModuleId, tenantId, editCreateLearningModule, options) {
        return exports.AdminLearningModuleApiFp(this.configuration).editLearningModule(learningModuleId, tenantId, editCreateLearningModule, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.AdminLearningModuleApi = AdminLearningModuleApi;
